import { ContextApi } from 'contexts/Localization/types'

import { QuestSymbol, QuestCategory, QuestType, QuestFrequency, QuestConfigsRecord } from './models/quest'

const getQuestConfigs = (t: ContextApi['t']): QuestConfigsRecord => ({
  [QuestSymbol.ADOPT]: {
    name: t('Adopt'),
    description: t('Get ready to gem!'),
    category: QuestCategory.ONBOARDING,
    frequency: QuestFrequency.ONE_TIME_ONLY,
  },
  [QuestSymbol.TEAM_UP]: {
    name: t('Team Up'),
    description: t('Teamwork makes the dream work!'),
    category: QuestCategory.ONBOARDING,
    frequency: QuestFrequency.ONE_TIME_ONLY,
  },
  [QuestSymbol.BARTER]: {
    name: t('Barter'),
    description: t('Trade in your mined gems!'),
    category: QuestCategory.DAILY_WORK,
    type: QuestType.SWAP,
    frequency: QuestFrequency.UNLIMITED,
    variableExpRules: [
      {
        cumulativeUsd: { from: 0, to: 20 },
        expPerUsd: 1,
      },
      {
        cumulativeUsd: { from: 20, to: 500 },
        expPerUsd: 0.1,
      },
      {
        cumulativeUsd: { from: 500 },
        expPerUsd: 0.001,
      },
    ],
  },
  [QuestSymbol.MOLE_OPOLY]: {
    name: 'Mole-opoly',
    description: 'Do you want to be a mole-ionaire?',
    category: QuestCategory.DAILY_WORK,
    type: QuestType.XVVS,
    frequency: QuestFrequency.UNLIMITED,
    variableExpRules: [
      {
        cumulativeUsd: { from: 0, to: 100 },
        expPerUsd: 1,
      },
      {
        cumulativeUsd: { from: 100, to: 300 },
        expPerUsd: 0.1,
      },
      {
        cumulativeUsd: { from: 300 },
        expPerUsd: 0.001,
      },
    ],
  },
  [QuestSymbol.HYDRATE]: {
    name: t('Hydrate'),
    description: t('Give traders the liquidity they crave!'),
    category: QuestCategory.DAILY_WORK,
    frequency: QuestFrequency.ONCE_A_DAY,
    type: QuestType.LIQUIDITY,
  },
  [QuestSymbol.PROFIT]: {
    name: t('Profit'),
    description: t('Profit sharing is caring!'),
    category: QuestCategory.DAILY_WORK,
    frequency: QuestFrequency.ONCE_A_DAY,
    type: QuestType.XVVS,
  },
  [QuestSymbol.SOCIALISE]: {
    name: t('Socialise'),
    description: t('We love friends - the mole the merrier!'),
    category: QuestCategory.MOLE_CARE,
    frequency: QuestFrequency.ONCE_A_DAY,
  },
  [QuestSymbol.FARM]: {
    name: t('Farm'),
    description: t('Harvest your gems for fruitful rewards!'),
    category: QuestCategory.DAILY_WORK,
    frequency: QuestFrequency.ONCE_A_DAY,
    type: QuestType.FARM,
  },
  [QuestSymbol.GOLD_DIGGER]: {
    name: t('Gold digger'),
    description: t('Time to discover hidden gems!'),
    category: QuestCategory.SPECIAL_MISSION,
    frequency: QuestFrequency.EVENT_DRIVEN,
    type: QuestType.IGO,
  },
  [QuestSymbol.GACHA]: {
    name: t('Redeem Gachapon Egg'),
    description: t('Lucky draw!'),
    category: QuestCategory.DAILY_WORK,
  },
  [QuestSymbol.MOLE_DASH]: {
    name: t('Mole Dash'),
    category: QuestCategory.GAME_CHALLENGES,
    frequency: QuestFrequency.UNLIMITED,
  },
})

export default getQuestConfigs
